






































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {在庫照会結果型, 在庫照会検索条件型, 在庫照会明細型, 在庫場所型, 在庫照会検索条件型バリデータ一覧} from '@/type/refstock/item';
import {在庫数区分型} from '@/type/refstock/types';
import {
  ValidationResult,
} from '@/type/validation/result';
import moment from 'moment';
import {loginModule} from '@/store/authentication/login';
import StockItemClassSelector from '@/components/stock/item/StockItemClassSelector.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';

import YearMonthPicker from '@/components/datepicker/YearMonthPicker.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {progress} from '@/script/progress';
import UsageClassSelector from '@/components/item/UsageClassSelector.vue';

@Component({
  components: {
    YearMonthPicker,
    StockItemClassSelector,
    ButtonPanel,
    IconButton,
    AlertDialog,
    ConfirmDialog,
    NormalButton,
    UsageClassSelector,
  },
})
export default class ReferenceStock extends Vue {
  // data
  在庫場所一覧: 在庫場所型[] = [];
  在庫照会結果: 在庫照会結果型|null = null;
  在庫照会明細一覧: 在庫照会明細型[] = [];
  在庫照会検索条件: 在庫照会検索条件型 = new 在庫照会検索条件型();
  在庫数区分一覧 = Object.keys(在庫数区分型);
  選択されている明細の商品コード: string|null = null;
  アラートメッセージ: string | string[] | null = null;
  バリデーション結果: ValidationResult = new ValidationResult(在庫照会検索条件型バリデータ一覧);

  // computed
  get 所属部署コード(): string {
    return loginModule.部署コードを取得する;
  }

  get 全部署の結果が表示されている(): boolean {
    return this.在庫照会結果 !== null && this.在庫照会結果.ヘッダー.在庫場所.部署コード === null;
  }

  get Excelをダウンロードできる(): boolean {
    return 0 < this.在庫照会明細一覧.length;
  }

  get 表示件数(): number {
    return this.在庫照会明細一覧.length;
  }

  // watched properties
  @Watch('在庫照会検索条件.在庫場所')
  在庫場所が変更された(): void {
    const 現在年月: string = moment().format('YYYY-MM');
    this.在庫照会検索条件.在庫年月 = 現在年月;
  }

  アラートダイアログを表示する(メッセージ: string | string[]): void {
    if (typeof メッセージ === 'string') {
      this.アラートメッセージ = [メッセージ];
    } else {
      this.アラートメッセージ = メッセージ;
    }
    this.$modal.show('アラート');
  }

  Excel出力確認ダイアログを開く(): void {
    this.$modal.show('Excel出力確認ダイアログ');
  }

  Excel出力確認ダイアログを閉じる(): void {
    this.$modal.hide('Excel出力確認ダイアログ');
  }

  async 在庫場所名取得(): Promise<void> {
    try {
      this.在庫場所一覧 = await api.在庫照会の在庫場所一覧を取得する();
      this.在庫照会検索条件.在庫場所 = this.所属部署コード;
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  async 検索開始(): Promise<void> {
    if (this.バリデーション結果.hasErrors) {
      this.バリデーションエラーを表示する();
      return;
    }

    await progress(this.在庫を検索する);
  }

  async 在庫を検索する(): Promise<void> {
    this.明細行の選択をクリア();

    try {
      this.在庫照会結果 = await api.在庫を照会する(this.在庫照会検索条件);
      if (this.在庫照会結果 !== null) {
        this.在庫照会明細一覧 = this.在庫照会結果.明細一覧;
        if (this.在庫照会明細一覧.length === 0) {
          this.アラートダイアログを表示する('対象データはありません');
          return;
        }
        if (this.在庫照会結果.アラートメッセージ) {
          this.アラートダイアログを表示する(this.在庫照会結果.アラートメッセージ);
        }
      } else {
        this.在庫照会明細一覧 = [];
        this.アラートダイアログを表示する('対象データはありません');
      }
    } catch (error) {
      this.APIアラートメッセージを表示する(error);
    }
  }

  async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.バリデーション結果.hasErrors) {
      this.バリデーションエラーを表示する();
      return;
    }
    this.Excel出力確認ダイアログを開く();
  }

  async Excelファイルを出力する(): Promise<void> {
    this.Excel出力確認ダイアログを閉じる();
    await progress(this.在庫一覧表の出力);
  }

  async 在庫一覧表の出力(): Promise<void> {
    await download.在庫一覧表を出力する('/api/refstock/download/excel', '在庫一覧表.xlsx', this.在庫照会検索条件);
  }

  明細行の選択をクリア(): void {
    this.選択されている明細の商品コード = null;
  }

  明細行を選択(在庫照会明細: 在庫照会明細型) {
    this.選択されている明細の商品コード = 在庫照会明細.商品コード;
  }

  明細行が選択されている(在庫照会明細: 在庫照会明細型): boolean {
    return  this.選択されている明細の商品コード === 在庫照会明細.商品コード;
  }

  APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }

  APIアラートメッセージを表示する(error: any): void {
    const APIアラートメッセージ = this.APIアラートメッセージを取得(error.data);
    this.アラートダイアログを表示する(APIアラートメッセージ);
  }

  バリデーションエラーを表示する() {
    this.アラートダイアログを表示する(this.バリデーション結果.getMessages(false));
  }

  hasError(name: string): any {
    return {'input-error': this.バリデーション結果.hasError(name)};
  }

  // lifecycle hooks
  created(): void {
    this.在庫場所名取得();
  }

  beforeUpdate() {
    this.バリデーション結果.validate(this.在庫照会検索条件);
  }
}
